import Nullstack from 'nullstack';
export default function IconAlarm({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-alarm",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "13",
    r: "7"
  }), "   ", Nullstack.element("polyline", {
    points: "12 10 12 13 14 13"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "4",
    x2: "4.25",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "4",
    x2: "19.75",
    y2: "6"
  }), " ");
}